import clsx from 'clsx'
import type { ComponentPropsWithoutRef } from 'react'

export type AdminCheckboxProps = Omit<ComponentPropsWithoutRef<'input'>, 'type'>

export const AdminCheckbox = ({ ...props }: AdminCheckboxProps) => {
  return (
    <input
      type="checkbox"
      {...props}
      className={clsx('checkbox', props.className)}
    />
  )
}
